import axios from "../interceptors/axios";

export const getAllHome = async () => {
  try {
    const response = await axios.get("/api/home", {});
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

//buscar um projeto pelo idexport const getProjectDetailsById = async (id) => {
export const getProjectDetailsById = async (id) => {
  try {
    const response = await axios.get(`/api/projects/chapters/${id}`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

export const getAllDash = async () => {
  try {
    const response = await axios.get("/api/dashboard", {});
    return response;
  } catch (error) {
    console.error("Error:", error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

export const getGenders = async (params) => {
  try {

  const response = await axios.get("/api/home/gender", {params});
  return response;
  }catch (error) {
    console.error("Error:", error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
}

export const getEssentials = async () => {
  try {
    const response = await axios.get("/api/home/essentials", {});
    console.log('✅ getEssentials sucesso:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error getEssentials:", error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

export const getSection = async (sectionType) => {
  try {
    const response = await axios.get(`/api/home/section/${sectionType}`, {});
    console.log(`✅ getSection(${sectionType}) sucesso:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error getSection(${sectionType}):`, error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

export const HOME_PUBLIC_SECTION_TYPES = {
  dominaram: "dominaram",
  monthlyBattle: "monthly_battle",
  exclusiveProjects: "exclusive_projects",
  completedProjects: "completed_projects",
};

export const getHomePublicSection = (sectionType) => getSection(sectionType);
